import { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Input,
  Label,
  Switch,
} from '@shared/ui/primitives';
import { portalMcpApi, type McpGlobalLimits } from '@/services/portalMcpApi';
import { McpAdminPageShell } from './McpAdminShell';

export function McpGlobalLimitsPage() {
  const [form, setForm] = useState<McpGlobalLimits | null>(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    portalMcpApi
      .getLimits()
      .then(setForm)
      .catch((e) => setError(e instanceof Error ? e.message : 'load failed'));
  }, []);

  const save = async () => {
    if (!form) return;
    setSaving(true);
    try {
      const updated = await portalMcpApi.putLimits(form);
      setForm(updated);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'save failed');
    } finally {
      setSaving(false);
    }
  };

  if (!form) {
    return (
      <McpAdminPageShell title="MCP 전역 한도" description="Tenant 기본 Rate Limit">
        {error && <Alert variant="error" title="오류" description={error} />}
      </McpAdminPageShell>
    );
  }

  return (
    <McpAdminPageShell title="MCP 전역 한도" description="Tenant 미지정 시 기본 Tool call·세션 한도">
      {error && <Alert variant="error" title="오류" description={error} />}
      <div className="space-y-4 max-w-md">
        <div className="space-y-2">
          <Label>일일 Tool call / Tenant</Label>
          <Input
            type="number"
            value={form.dailyToolCallsPerTenant}
            onChange={(e) =>
              setForm((f) => f && { ...f, dailyToolCallsPerTenant: Number(e.target.value) })
            }
          />
        </div>
        <div className="space-y-2">
          <Label>동시 MCP 세션 / Tenant</Label>
          <Input
            type="number"
            value={form.maxConcurrentSessionsPerTenant}
            onChange={(e) =>
              setForm((f) => f && { ...f, maxConcurrentSessionsPerTenant: Number(e.target.value) })
            }
          />
        </div>
        <div className="space-y-2">
          <Label>Tool output max (KB)</Label>
          <Input
            type="number"
            value={form.maxToolOutputKb}
            onChange={(e) => setForm((f) => f && { ...f, maxToolOutputKb: Number(e.target.value) })}
          />
        </div>
        <div className="flex items-center justify-between">
          <Label>T3 Write → ITSM 승인 필수</Label>
          <Switch
            checked={form.t3WriteRequiresItsmApproval}
            onCheckedChange={(v) => setForm((f) => f && { ...f, t3WriteRequiresItsmApproval: v })}
          />
        </div>
        <Button onClick={save} disabled={saving}>
          저장
        </Button>
      </div>
    </McpAdminPageShell>
  );
}
